import { API } from "../../constants/constants"
import { PrimaryIconCollectionType } from "../../types/mainModulTypes"
import { HashLink } from "react-router-hash-link"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import { useAccessibility } from "../../context/AccessibilityContext"

export default function PrimaryIconCollection(props: PrimaryIconCollectionType) {
    const { getCursorPointerClass } = useAccessibility()

    return (
        <div className="max-w-content-sm mx-auto text-center px-4 lg:px-0">
            <BaseSubheadline label={props?.primaryIconCollectionHeading} />
            <BaseRichtext content={props.primaryIconCollectionText} classProps="pt-2 pb-8" />
            <div className="flex flex-wrap justify-center gap-8">
                {props.primaryIconCollectionCollection.map((item, index) => (
                    <HashLink
                        to={item.primaryIconCollectionCollectionItemUrl}
                        key={index}
                        className={`group w-48 aspect-square relative [perspective:1000px]  ${getCursorPointerClass()}`}>
                        {/* Container für die flip-Animation */}
                        <div className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
                            {/* Vorderseite der Card */}
                            <div
                                className="absolute inset-0 flex justify-center items-center [backface-visibility:hidden] border-8 bg-white rounded-default"
                                style={{ borderColor: item.primaryIconCollectionCollectionItemColor }}>
                                <img
                                    src={API + item.primaryIconCollectionCollectionItemIcon?.url}
                                    alt={
                                        item.primaryIconCollectionCollectionItemIcon?.description ??
                                        item.primaryIconCollectionCollectionItemIcon?.name
                                    }
                                    className="w-full h-full object-contain p-4"
                                />
                            </div>
                            {/* Rückseite der Card */}
                            <div
                                className="absolute inset-0 flex justify-center items-center [backface-visibility:hidden] [transform:rotateY(180deg)] bg-white border-8 rounded-default px-2"
                                style={{ borderColor: item.primaryIconCollectionCollectionItemColor }}>
                                <BaseSubheadline
                                    classProps={`text-center`}
                                    label={item.primaryIconCollectionCollectionItemText}
                                    customColor={item.primaryIconCollectionCollectionItemColor}
                                />
                            </div>
                        </div>
                    </HashLink>
                ))}
            </div>
        </div>
    )
}
